module.exports = __webpack_public_path__ + "img/attention-detail2.c1719c42.jpg";